/* eslint-disable max-lines */

export const countryValidations = {
  AF: {
    ExtensionData: null,
    Iso2Code: "AF",
    Iso3Code: "AFG",
    DefaultCulture: "ps-AF",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["ps-AF", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "93",
    PaymentTerm: "60",
  },
  AL: {
    ExtensionData: null,
    Iso2Code: "AL",
    Iso3Code: "ALB",
    DefaultCulture: "sq-AL",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["sq-AL", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "355",
    PaymentTerm: "60",
  },
  AQ: {
    ExtensionData: null,
    Iso2Code: "AQ",
    Iso3Code: "ATA",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: null,
    PaymentTerm: "60",
  },
  DZ: {
    ExtensionData: null,
    Iso2Code: "DZ",
    Iso3Code: "DZA",
    DefaultCulture: "ar-DZ",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en", "ar"],
    SupportedCultures: ["ar-DZ", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "213",
    PaymentTerm: "60",
  },
  AS: {
    ExtensionData: null,
    Iso2Code: "AS",
    Iso3Code: "ASM",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  AD: {
    ExtensionData: null,
    Iso2Code: "AD",
    Iso3Code: "AND",
    DefaultCulture: "ca-ES",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["ca"],
    SupportedCultures: ["ca-ES", "en-US"],
    IsPostalCodeRequired: "true",
    PostalCodeRegex: "^[aA][dD][0-9]{3,3}$",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "WesternEurope",
    CountryCallingCodes: "376",
    PaymentTerm: "60",
  },
  AO: {
    ExtensionData: null,
    Iso2Code: "AO",
    Iso3Code: "AGO",
    DefaultCulture: "pt-PT",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "pt-PT"],
    SupportedCultures: ["pt-PT", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "244",
    PaymentTerm: "60",
  },
  AG: {
    ExtensionData: null,
    Iso2Code: "AG",
    Iso3Code: "ATG",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  AZ: {
    ExtensionData: null,
    Iso2Code: "AZ",
    Iso3Code: "AZE",
    DefaultCulture: "az-Latn-AZ",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["az-Latn-AZ", "en-US"],
    PostalCodeRegex: "^([aA][zZ][ ]?)?[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "994",
    PaymentTerm: "60",
  },
  AR: {
    ExtensionData: null,
    Iso2Code: "AR",
    Iso3Code: "ARG",
    DefaultCulture: "es-AR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "es"],
    SupportedCultures: ["es-AR", "en-US"],
    PostalCodeRegex: "^[a-zA-Z][0-9]{4,4}[a-zA-Z]{3,3}$|^[a-zA-Z]?[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: null,
    CountryCallingCodes: "54",
    PaymentTerm: "60",
  },
  AU: {
    ExtensionData: null,
    Iso2Code: "AU",
    Iso3Code: "AUS",
    DefaultCulture: "en-AU",
    States: [
      "Australian Capital Territory",
      "Jervis Bay Territory",
      "New South Wales",
      "Northern Territory",
      "Queensland",
      "South Australia",
      "Tasmania",
      "Victoria",
      "Western Australia",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-AU", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex:
      "^((ABN)\\s)?\\d{2}\\s\\d{3}\\s\\d{3}\\s\\d{3}(\\s\\d{3})?$|^(ABN)?\\d{11}(\\d{3})?$",
    IsRegistrationNumberSupported: "false",
    IsTaxIdSupported: "false",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "61",
    PaymentTerm: "60",
    SalesTerritory: "Australia",

    IsSalesTerritoryRequired: "true",
  },
  AT: {
    ExtensionData: null,
    Iso2Code: "AT",
    Iso3Code: "AUT",
    DefaultCulture: "de-AT",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "de"],
    SupportedCultures: ["de-AT", "en-US"],
    PostalCodeRegex: "^[1-9][0-9]{3,3}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^ATU[\\d]{8,8}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "ATU########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "43",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  BS: {
    ExtensionData: null,
    Iso2Code: "BS",
    Iso3Code: "BHS",
    DefaultCulture: "en-GB",
    States: [
      "Acklins",
      "Berry Islands",
      "Bimini",
      "Black Point",
      "Cat Island",
      "Central Abaco",
      "Central Andros",
      "Central Eleuthera",
      "City of Freeport",
      "Crooked Island and Long Cay",
      "East Grand Bahama",
      "Exuma",
      "Grand Cay",
      "Harbour Island",
      "Hope Town",
      "Inagua",
      "Long Island",
      "Mangrove Cay",
      "Mayaguana",
      "Moore\u2018s Island",
      "New Providence",
      "North Abaco",
      "North Andros",
      "North Eleuthera",
      "Ragged Island",
      "Rum Cay",
      "San Salvador",
      "South Abaco",
      "South Andros",
      "South Eleuthera",
      "Spanish Wells",
      "West Grand Bahama",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-GB", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{9}$",
    TaxIdFormat: "123456789",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1242",
    PaymentTerm: "60",
  },
  BH: {
    ExtensionData: null,
    Iso2Code: "BH",
    Iso3Code: "BHR",
    DefaultCulture: "ar-BH",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "ar"],
    SupportedCultures: ["ar-BH", "en-US"],
    PostalCodeRegex: "^[0-9]{3,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^2\\d{14}$",
    TaxIdFormat: "212345678901234",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "973",
    PaymentTerm: "60",
    SalesTerritory: "Bahrain",

    IsSalesTerritoryRequired: "true",
  },
  BD: {
    ExtensionData: null,
    Iso2Code: "BD",
    Iso3Code: "BGD",
    DefaultCulture: "bn-BD",
    States: [
      "Barisal",
      "Chittagong",
      "Dhaka",
      "Khulna",
      "Mymensingh",
      "Rajshahi",
      "Rangpur",
      "Sylhet",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["en"],
    SupportedCultures: ["bn-BD", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{9}\\-\\d{4}$",
    TaxIdFormat: "123456780-1234",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "880",
    PaymentTerm: "60",
  },
  AM: {
    ExtensionData: null,
    Iso2Code: "AM",
    Iso3Code: "ARM",
    DefaultCulture: "hy-AM",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["hy-AM", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{8}$",
    TaxIdSample: "12345678",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "374",
    PaymentTerm: "60",
  },
  BB: {
    ExtensionData: null,
    Iso2Code: "BB",
    Iso3Code: "BRB",
    DefaultCulture: "en-GB",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-GB", "en-US"],
    PostalCodeRegex: "^[a-zA-Z]{2,2}[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1246",
    PaymentTerm: "60",
  },
  BE: {
    ExtensionData: null,
    Iso2Code: "BE",
    Iso3Code: "BEL",
    DefaultCulture: "fr-BE",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "fr", "nl"],
    SupportedCultures: ["fr-BE", "nl-BE", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^BE0[\\d]{9,9}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "BE0#########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "32",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  BM: {
    ExtensionData: null,
    Iso2Code: "BM",
    Iso3Code: "BMU",
    DefaultCulture: "en-GB",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-GB", "en-US"],
    PostalCodeRegex: "^[a-zA-Z]{2,2}[ ]?[0-9]{2,2}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1441",
    PaymentTerm: "60",
  },
  BT: {
    ExtensionData: null,
    Iso2Code: "BT",
    Iso3Code: "BTN",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "975",
    PaymentTerm: "60",
  },
  BO: {
    ExtensionData: null,
    Iso2Code: "BO",
    Iso3Code: "BOL",
    DefaultCulture: "es-BO",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "es"],
    SupportedCultures: ["es-BO", "en-US"],
    PostalCodeRegex: "^[0-9]{4,5}$",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "591",
    PaymentTerm: "60",
  },
  BA: {
    ExtensionData: null,
    Iso2Code: "BA",
    Iso3Code: "BIH",
    DefaultCulture: "bs-Latn-BA",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["bs-Latn-BA", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "387",
    PaymentTerm: "60",
  },
  BW: {
    ExtensionData: null,
    Iso2Code: "BW",
    Iso3Code: "BWA",
    DefaultCulture: "en-GB",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-GB", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "267",
    PaymentTerm: "60",
  },
  BV: {
    ExtensionData: null,
    Iso2Code: "BV",
    Iso3Code: "BVT",
    DefaultCulture: "nb-NO",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["nb", "en"],
    SupportedCultures: ["nb-NO", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "WesternEurope",
    CountryCallingCodes: "47",
    PaymentTerm: "60",
  },
  BR: {
    ExtensionData: null,
    Iso2Code: "BR",
    Iso3Code: "BRA",
    DefaultCulture: "pt-BR",
    States: [
      "Acre",
      "Alagoas",
      "Amap\u00e1",
      "Amazonas",
      "Bahia",
      "Cear\u00e1",
      "Distrito Federal",
      "Esp\u00edrito Santo",
      "Goi\u00e1s",
      "Maranh\u00e3o",
      "Mato Grosso",
      "Mato Grosso do Sul",
      "Minas Gerais",
      "Par\u00e1",
      "Para\u00edba",
      "Paran\u00e1",
      "Pernambuco",
      "Piau\u00ed",
      "Rio de Janeiro",
      "Rio Grande do Norte",
      "Rio Grande do Sul",
      "Rond\u00f4nia",
      "Roraima",
      "Santa Catarina",
      "S\u00e3o Paulo",
      "Sergipe",
      "Tocantins",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["en", "pt-BR"],
    SupportedCultures: ["pt-BR", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}[-][0-9]{3,3}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\d{14}$|^\\d{2}\\.\\d{3}\\.\\d{3}\\/\\d{4}\\-\\d{2}$",
    IsRegistrationNumberSupported: "true",
    IsTaxIdSupported: "true",
    TaxIdSample: "04.712.500/0001-07",
    TaxIdFormat: "##.###.###/####-##",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "55",
    PaymentTerm: "60",
  },
  BZ: {
    ExtensionData: null,
    Iso2Code: "BZ",
    Iso3Code: "BLZ",
    DefaultCulture: "en-BZ",
    States: ["Belize", "Cayo", "Corozal", "Orange Walk", "Stann Creek", "Toledo"],

    IsStateRequired: "true",
    SupportedLanguages: ["en", "es"],
    SupportedCultures: ["en-BZ", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "501",
    PaymentTerm: "60",
  },
  IO: {
    ExtensionData: null,
    Iso2Code: "IO",
    Iso3Code: "IOT",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "246",
    PaymentTerm: "60",
  },
  SB: {
    ExtensionData: null,
    Iso2Code: "SB",
    Iso3Code: "SLB",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "677",
    PaymentTerm: "60",
  },
  VG: {
    ExtensionData: null,
    Iso2Code: "VG",
    Iso3Code: "VGB",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  BN: {
    ExtensionData: null,
    Iso2Code: "BN",
    Iso3Code: "BRN",
    DefaultCulture: "ms-BN",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "ms"],
    SupportedCultures: ["ms-BN", "en-US"],
    PostalCodeRegex: "^[a-zA-Z]{2,2}[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "673",
    PaymentTerm: "60",
  },
  BG: {
    ExtensionData: null,
    Iso2Code: "BG",
    Iso3Code: "BGR",
    DefaultCulture: "bg-BG",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "bg"],
    SupportedCultures: ["bg-BG", "en-US"],
    PostalCodeRegex: "^[1-9][0-9]{3,3}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^BG[\\d]{9,10}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "BG##########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "359",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  BI: {
    ExtensionData: null,
    Iso2Code: "BI",
    Iso3Code: "BDI",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "257",
    PaymentTerm: "60",
  },
  BY: {
    ExtensionData: null,
    Iso2Code: "BY",
    Iso3Code: "BLR",
    DefaultCulture: "be-BY",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["ru", "en"],
    SupportedCultures: ["be-BY", "en-US"],
    PostalCodeRegex: "^[0-9]{6,6}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{9}$",
    TaxIdSample: "123456789",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "375",
    PaymentTerm: "60",
  },
  KH: {
    ExtensionData: null,
    Iso2Code: "KH",
    Iso3Code: "KHM",
    DefaultCulture: "km-KH",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["km-KH", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^L001\\-\\d{9}$|^B0\\d{2}\\-\\d{9}$|^K0\\d{2}\\-\\d{9}$|^E0\\d{2}\\-\\d{10}$",
    TaxIdFormat: "L001-123456789; B012-123456789; K012-123456789; E012-1234567890",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "855",
    PaymentTerm: "60",
  },
  CM: {
    ExtensionData: null,
    Iso2Code: "CM",
    Iso3Code: "CMR",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "fr"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^[A-Za-z]{1}\\d{12}[A-Za-z]{1}$",
    TaxIdFormat: "A123456789000A; a123456789000a",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "237",
    PaymentTerm: "60",
  },
  CA: {
    ExtensionData: null,
    Iso2Code: "CA",
    Iso3Code: "CAN",
    DefaultCulture: "en-CA",
    States: ["AB", "BC", "MB", "NB", "NL", "NT", "NS", "NU", "ON", "PE", "QC", "SK", "YT"],

    IsStateRequired: "true",
    SupportedLanguages: ["en", "fr"],
    SupportedCultures: ["fr-CA", "en-CA", "en-US"],
    PostalCodeRegex: "^[a-zA-Z][0-9][a-zA-Z][ ]?[0-9][a-zA-Z][0-9]$",
    IsPostalCodeRequired: "true",
    PhoneNumberRegex:
      "^(1[ \\-\\/\\.]?)?(\\((\\d{3})\\)|(\\d{3}))[ \\-\\/\\.]?(\\d{3})[ \\-\\/\\.]?(\\d{4})$",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    IsTaxIdSupported: "false",
    TaxIdSample: "R335569",
    TaxIdFormat: "R######",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
    SalesTerritory: "Canada",

    IsSalesTerritoryRequired: "true",
  },
  CV: {
    ExtensionData: null,
    Iso2Code: "CV",
    Iso3Code: "CPV",
    DefaultCulture: "pt-CV",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "pt-PT"],
    SupportedCultures: ["pt-CV", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "238",
    PaymentTerm: "60",
  },
  KY: {
    ExtensionData: null,
    Iso2Code: "KY",
    Iso3Code: "CYM",
    DefaultCulture: "en-GB",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-GB", "en-US"],
    PostalCodeRegex: "^[a-zA-Z]{2,2}[0-9]-[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1345",
    PaymentTerm: "60",
  },
  CF: {
    ExtensionData: null,
    Iso2Code: "CF",
    Iso3Code: "CAF",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "236",
    PaymentTerm: "60",
  },
  LK: {
    ExtensionData: null,
    Iso2Code: "LK",
    Iso3Code: "LKA",
    DefaultCulture: "si-LK",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["si-LK", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\d{9}(-\\d{4})?$",
    IsTaxIdSupported: "false",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "94",
    PaymentTerm: "60",
  },
  TD: {
    ExtensionData: null,
    Iso2Code: "TD",
    Iso3Code: "TCD",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "235",
    PaymentTerm: "60",
  },
  CL: {
    ExtensionData: null,
    Iso2Code: "CL",
    Iso3Code: "CHL",
    DefaultCulture: "es-CL",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "es"],
    SupportedCultures: ["es-CL", "en-US"],
    PostalCodeRegex: "^([1-9]\\d{2})[ \\-]?(\\d{4})$",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{8}\\-\\d{1}|^\\d{8}\\-K$",
    TaxIdFormat: "12345678-1; 12345678-K",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "56",
    PaymentTerm: "60",
  },
  CN: {
    ExtensionData: null,
    Iso2Code: "CN",
    Iso3Code: "CHN",
    DefaultCulture: "zh-CN",
    States: [
      "AH",
      "BJ",
      "CQ",
      "FJ",
      "GD",
      "GS",
      "GX",
      "GZ",
      "HA",
      "HB",
      "HE",
      "HI",
      "HL",
      "HN",
      "JL",
      "JS",
      "JX",
      "LN",
      "NM",
      "NX",
      "QH",
      "SC",
      "SD",
      "SH",
      "SN",
      "SX",
      "TJ",
      "XJ",
      "XZ",
      "YN",
      "ZJ",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["zh-CHS", "en"],
    SupportedCultures: ["zh-CN", "en-US"],
    PostalCodeRegex: "^[0-9]{6,6}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\w{3}\\s?\\w{3}(\\s?\\w{3}\\s?\\w{3}\\s?\\w{3}|\\w{12}|\\w{14})$",
    IsTaxIdSupported: "false",
    IsTaxIdOptional: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "China",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "86",
    PaymentTerm: "60",
    SalesTerritory: "China",

    IsSalesTerritoryRequired: "true",
  },
  TW: {
    ExtensionData: null,
    Iso2Code: "TW",
    Iso3Code: "TWN",
    DefaultCulture: "zh-TW",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "zh-CHT"],
    SupportedCultures: ["zh-TW", "en-US"],
    PostalCodeRegex: "^([0-9]{3}|[0-9]{5}|[0-9]{6})$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\d{8}$|^\\d{2}\\s\\d{2}\\s\\d{2}\\s\\d{2}$",
    IsTaxIdOptional: "false",
    TaxIdSample: "12345678",
    TaxIdFormat: "########",
    IsRegistrationNumberSupported: "true",
    ResellerAgreementRegion: "Taiwan",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "886",
    PaymentTerm: "60",
    SalesTerritory: "Taiwan",

    IsSalesTerritoryRequired: "true",
  },
  CX: {
    ExtensionData: null,
    Iso2Code: "CX",
    Iso3Code: "CXR",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "61",
    PaymentTerm: "60",
  },
  CC: {
    ExtensionData: null,
    Iso2Code: "CC",
    Iso3Code: "CCK",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "61",
    PaymentTerm: "60",
  },
  CO: {
    ExtensionData: null,
    Iso2Code: "CO",
    Iso3Code: "COL",
    DefaultCulture: "es-CO",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "es"],
    SupportedCultures: ["es-CO", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{9}\\-\\d{1}$",
    TaxIdFormat: "012345678-1",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "57",
    PaymentTerm: "60",
  },
  KM: {
    ExtensionData: null,
    Iso2Code: "KM",
    Iso3Code: "COM",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "269",
    PaymentTerm: "60",
  },
  YT: {
    ExtensionData: null,
    Iso2Code: "YT",
    Iso3Code: "MYT",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "262",
    PaymentTerm: "60",
  },
  CG: {
    ExtensionData: null,
    Iso2Code: "CG",
    Iso3Code: "COG",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "242",
    PaymentTerm: "60",
  },
  CK: {
    ExtensionData: null,
    Iso2Code: "CK",
    Iso3Code: "COK",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "682",
    PaymentTerm: "60",
  },
  CR: {
    ExtensionData: null,
    Iso2Code: "CR",
    Iso3Code: "CRI",
    DefaultCulture: "es-CR",
    States: [
      "Alajuela",
      "Cartago",
      "Guanacaste",
      "Heredia",
      "Lim\u00f3n",
      "Puntarenas",
      "San Jos\u00e9",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["en", "es"],
    SupportedCultures: ["es-CR", "en-US"],
    PostalCodeRegex: "^([0-9]{4,5})?$",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "506",
    PaymentTerm: "60",
  },
  HR: {
    ExtensionData: null,
    Iso2Code: "HR",
    Iso3Code: "HRV",
    DefaultCulture: "hr-HR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "hr"],
    SupportedCultures: ["hr-HR", "en-US"],
    PostalCodeRegex: "^[1-9][0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^HR[\\d]{11,11}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "HR###########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "385",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  CW: {
    ExtensionData: null,
    Iso2Code: "CW",
    Iso3Code: "CUW",
    DefaultCulture: "nl-NL",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "nl"],
    SupportedCultures: ["nl-NL", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "599",
    PaymentTerm: "60",
  },
  CY: {
    ExtensionData: null,
    Iso2Code: "CY",
    Iso3Code: "CYP",
    DefaultCulture: "el-GR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "el"],
    SupportedCultures: ["el-GR", "en-US"],
    PostalCodeRegex: "^[1-9][0-9]{3,3}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^CY[\\d]{8,8}[A-Z]$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "CY########x",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "357",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  CZ: {
    ExtensionData: null,
    Iso2Code: "CZ",
    Iso3Code: "CZE",
    DefaultCulture: "cs-CZ",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "cs"],
    SupportedCultures: ["cs-CZ", "en-US"],
    PostalCodeRegex: "^[0-9]{3,3}[ ][0-9]{2,2}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^CZ[\\d]{8,10}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "CZ#########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "420",
    PaymentTerm: "60",
  },
  BJ: {
    ExtensionData: null,
    Iso2Code: "BJ",
    Iso3Code: "BEN",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "229",
    PaymentTerm: "60",
  },
  DK: {
    ExtensionData: null,
    Iso2Code: "DK",
    Iso3Code: "DNK",
    DefaultCulture: "da-DK",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "da"],
    SupportedCultures: ["da-DK", "en-US"],
    PostalCodeRegex: "^[1-9][0-9]{3,3}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^DK[\\d]{2,2}[\\d]{2,2}[\\d]{2,2}[\\d]{2,2}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "DK########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "45",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  DM: {
    ExtensionData: null,
    Iso2Code: "DM",
    Iso3Code: "DMA",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  DO: {
    ExtensionData: null,
    Iso2Code: "DO",
    Iso3Code: "DOM",
    DefaultCulture: "es-DO",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["es", "en"],
    SupportedCultures: ["es-DO", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  EC: {
    ExtensionData: null,
    Iso2Code: "EC",
    Iso3Code: "ECU",
    DefaultCulture: "es-EC",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["es", "en"],
    SupportedCultures: ["es-EC", "en-US"],
    PostalCodeRegex: "^[0-9]{6,6}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "593",
    PaymentTerm: "60",
  },
  SV: {
    ExtensionData: null,
    Iso2Code: "SV",
    Iso3Code: "SLV",
    DefaultCulture: "es-SV",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["es", "en"],
    SupportedCultures: ["es-SV", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "503",
    PaymentTerm: "60",
  },
  GQ: {
    ExtensionData: null,
    Iso2Code: "GQ",
    Iso3Code: "GNQ",
    DefaultCulture: "es-ES",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["es", "en"],
    SupportedCultures: ["es-ES", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "240",
    PaymentTerm: "60",
  },
  ET: {
    ExtensionData: null,
    Iso2Code: "ET",
    Iso3Code: "ETH",
    DefaultCulture: "am-ET",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["am-ET", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "251",
    PaymentTerm: "60",
  },
  ER: {
    ExtensionData: null,
    Iso2Code: "ER",
    Iso3Code: "ERI",
    DefaultCulture: "ar-SA",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["ar", "en"],
    SupportedCultures: ["ar-SA", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "291",
    PaymentTerm: "60",
  },
  EE: {
    ExtensionData: null,
    Iso2Code: "EE",
    Iso3Code: "EST",
    DefaultCulture: "et-EE",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "et"],
    SupportedCultures: ["et-EE", "en-US"],
    PostalCodeRegex: "^[1-9][0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^EE[\\d]{9,9}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "EE#########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "372",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  FO: {
    ExtensionData: null,
    Iso2Code: "FO",
    Iso3Code: "FRO",
    DefaultCulture: "fo-FO",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["da", "en"],
    SupportedCultures: ["fo-FO", "en-US"],
    PostalCodeRegex: "^[0-9]{3,3}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "298",
    PaymentTerm: "60",
  },
  FK: {
    ExtensionData: null,
    Iso2Code: "FK",
    Iso3Code: "FLK",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "500",
    PaymentTerm: "60",
  },
  GS: {
    ExtensionData: null,
    Iso2Code: "GS",
    Iso3Code: "SGS",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "500",
    PaymentTerm: "60",
  },
  FJ: {
    ExtensionData: null,
    Iso2Code: "FJ",
    Iso3Code: "FJI",
    DefaultCulture: "en-GB",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-GB", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{2}\\-\\d{5}\\-\\d{1}\\-\\d{1}$",
    TaxIdFormat: "11-57252-0-3",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "679",
    PaymentTerm: "60",
  },
  FI: {
    ExtensionData: null,
    Iso2Code: "FI",
    Iso3Code: "FIN",
    DefaultCulture: "fi-FI",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "fi", "sv"],
    SupportedCultures: ["fi-FI", "sv-FI", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^FI[\\d]{8,8}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "FI########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "358",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  FR: {
    ExtensionData: null,
    Iso2Code: "FR",
    Iso3Code: "FRA",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "fr"],
    SupportedCultures: ["fr-FR", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^FR[A-Z0-9]{2,2}[\\d]{9,9}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "FR__#########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "33",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  GF: {
    ExtensionData: null,
    Iso2Code: "GF",
    Iso3Code: "GUF",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "594",
    PaymentTerm: "60",
  },
  PF: {
    ExtensionData: null,
    Iso2Code: "PF",
    Iso3Code: "PYF",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "689",
    PaymentTerm: "60",
  },
  TF: {
    ExtensionData: null,
    Iso2Code: "TF",
    Iso3Code: "ATF",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "262",
    PaymentTerm: "60",
  },
  DJ: {
    ExtensionData: null,
    Iso2Code: "DJ",
    Iso3Code: "DJI",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "253",
    PaymentTerm: "60",
  },
  GA: {
    ExtensionData: null,
    Iso2Code: "GA",
    Iso3Code: "GAB",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: ">MiddleEastAndAfrica",
    CountryCallingCodes: "241",
    PaymentTerm: "60",
  },
  GE: {
    ExtensionData: null,
    Iso2Code: "GE",
    Iso3Code: "GEO",
    DefaultCulture: "ka-GE",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["ka-GE", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{9}$",
    TaxIdFormat: "123456789",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "995",
    PaymentTerm: "60",
  },
  GM: {
    ExtensionData: null,
    Iso2Code: "GM",
    Iso3Code: "GMB",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "220",
    PaymentTerm: "60",
  },
  PS: {
    ExtensionData: null,
    Iso2Code: "PS",
    Iso3Code: "PSE",
    DefaultCulture: "ar-SA",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["ar", "en"],
    SupportedCultures: ["ar-SA", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "970",
    PaymentTerm: "60",
  },
  DE: {
    ExtensionData: null,
    Iso2Code: "DE",
    Iso3Code: "DEU",
    DefaultCulture: "de-DE",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "de"],
    SupportedCultures: ["de-DE", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^DE[\\d]{9,9}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "DE#########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "49",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  GH: {
    ExtensionData: null,
    Iso2Code: "GH",
    Iso3Code: "GHA",
    DefaultCulture: "en-GB",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-GB", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^C\\d{10}$",
    TaxIdFormat: "C1234567890",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "233",
    PaymentTerm: "60",
  },
  GI: {
    ExtensionData: null,
    Iso2Code: "GI",
    Iso3Code: "GIB",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "WesternEurope",
    CountryCallingCodes: "350",
    PaymentTerm: "60",
  },
  KI: {
    ExtensionData: null,
    Iso2Code: "KI",
    Iso3Code: "KIR",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "686",
    PaymentTerm: "60",
  },
  GR: {
    ExtensionData: null,
    Iso2Code: "GR",
    Iso3Code: "GRC",
    DefaultCulture: "el-GR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "el"],
    SupportedCultures: ["el-GR", "en-US"],
    PostalCodeRegex: "(^[0-8][0-9]{4,4}$)|(^90000$)",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^EL[\\d]{9,9}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "EL#########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "30",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  GL: {
    ExtensionData: null,
    Iso2Code: "GL",
    Iso3Code: "GRL",
    DefaultCulture: "da-DK",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["da"],
    SupportedCultures: "da-DK",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "WesternEurope",
    CountryCallingCodes: "299",
    PaymentTerm: "60",
  },
  GD: {
    ExtensionData: null,
    Iso2Code: "GD",
    Iso3Code: "GRD",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  GP: {
    ExtensionData: null,
    Iso2Code: "GP",
    Iso3Code: "GLP",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "590",
    PaymentTerm: "60",
  },
  GU: {
    ExtensionData: null,
    Iso2Code: "GU",
    Iso3Code: "GUM",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  GT: {
    ExtensionData: null,
    Iso2Code: "GT",
    Iso3Code: "GTM",
    DefaultCulture: "es-GT",
    States: [
      "Alta Verapaz",
      "Baja Verapaz",
      "Chimaltenango",
      "Chiquimula",
      "El Progreso",
      "Escuintla",
      "Guatemala",
      "Huehuetenango",
      "Izabal",
      "Jalapa",
      "Jutiapa",
      "Pet\u00e9n",
      "Quetzaltenango",
      "Quich\u00e9",
      "Retalhuleu",
      "Sacatep\u00e9quez",
      "San Marcos",
      "Santa Rosa",
      "Solol\u00e1",
      "Suchitep\u00e9quez",
      "Totonicap\u00e1n",
      "Zacapa",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["es", "en"],
    SupportedCultures: ["es-GT", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{7}\\-[0-9]$",
    TaxIdFormat: "1234567-1",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "502",
    PaymentTerm: "60",
  },
  GN: {
    ExtensionData: null,
    Iso2Code: "GN",
    Iso3Code: "GIN",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "224",
    PaymentTerm: "60",
  },
  GY: {
    ExtensionData: null,
    Iso2Code: "GY",
    Iso3Code: "GUY",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "592",
    PaymentTerm: "60",
  },
  HT: {
    ExtensionData: null,
    Iso2Code: "HT",
    Iso3Code: "HTI",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "509",
    PaymentTerm: "60",
  },
  HM: {
    ExtensionData: null,
    Iso2Code: "HM",
    Iso3Code: "HMD",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "61",
    PaymentTerm: "60",
  },
  VA: {
    ExtensionData: null,
    Iso2Code: "VA",
    Iso3Code: "VAT",
    DefaultCulture: "it-IT",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["it"],
    SupportedCultures: "it-IT",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "WesternEurope",
    CountryCallingCodes: "379",
    PaymentTerm: "60",
  },
  HN: {
    ExtensionData: null,
    Iso2Code: "HN",
    Iso3Code: "HND",
    DefaultCulture: "es-HN",
    States: [
      "Atl\u00e1ntida",
      "Choluteca",
      "Col\u00f3n",
      "Comayagua",
      "Cop\u00e1n",
      "Cort\u00e9s",
      "El Para\u00edso",
      "Francisco Moraz\u00e1n",
      "Gracias a Dios",
      "Intibuc\u00e1",
      "Islas de la Bah\u00eda",
      "La Paz",
      "Lempira",
      "Ocotepeque",
      "Olancho",
      "Santa B\u00e1rbara",
      "Valle",
      "Yoro",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["en", "es"],
    SupportedCultures: ["es-HN", "en-US"],
    PostalCodeRegex: "^([a-zA-Z]{2,2}[0-9]{4,4}$)|\\d{5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "504",
    PaymentTerm: "60",
  },
  HK: {
    ExtensionData: null,
    Iso2Code: "HK",
    Iso3Code: "HKG",
    DefaultCulture: "zh-HK",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "zh-CHT"],
    SupportedCultures: ["zh-HK", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "852",
    PaymentTerm: "60",
    SalesTerritory: "Hong Kong",

    IsSalesTerritoryRequired: "true",
  },
  HU: {
    ExtensionData: null,
    Iso2Code: "HU",
    Iso3Code: "HUN",
    DefaultCulture: "hu-HU",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "hu"],
    SupportedCultures: ["hu-HU", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^HU[\\d]{8,8}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "HU########",
    IsTaxIdOptional: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "36",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  IS: {
    ExtensionData: null,
    Iso2Code: "IS",
    Iso3Code: "ISL",
    DefaultCulture: "is-IS",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["is-IS", "en-US"],
    PostalCodeRegex: "^([1-9][0-9]{2,2}|[0-9]{5,5})$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{5}$|^\\d{6}$",
    TaxIdFormat: "12345; 123456",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "354",
    PaymentTerm: "60",
  },
  IN: {
    ExtensionData: null,
    Iso2Code: "IN",
    Iso3Code: "IND",
    DefaultCulture: "en-IN",
    States: [
      "AP",
      "AR",
      "AS",
      "BR",
      "CT",
      "GA",
      "GJ",
      "HR",
      "HP",
      "JK",
      "JH",
      "KA",
      "KL",
      "MP",
      "MH",
      "MN",
      "ML",
      "MZ",
      "NL",
      "OR",
      "PB",
      "RJ",
      "SK",
      "TN",
      "TG",
      "TR",
      "UT",
      "UP",
      "WB",
      "AN",
      "CH",
      "DN",
      "LA",
      "DL",
      "LD",
      "PY",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["en", "hi"],
    SupportedCultures: ["en-IN", "hi-IN", "en-US"],
    PostalCodeRegex: "^[0-9]{6,6}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^[0-9]{2}[0-9A-Z]{13}$",
    IsRegistrationNumberSupported: "false",
    IsTaxIdOptional: "false",
    TaxIdSample: "12ABCDE3456F7G8",
    TaxIdType: "GSTINID",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "91",
    PaymentTerm: "60",
    SalesTerritory: "India",

    IsSalesTerritoryRequired: "true",
  },
  ID: {
    ExtensionData: null,
    Iso2Code: "ID",
    Iso3Code: "IDN",
    DefaultCulture: "id-ID",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "id"],
    SupportedCultures: ["id-ID", "en-US"],
    PostalCodeRegex: "^[1-9][0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\d{2}\\.\\d{3}\\.\\d{3}\\.\\d{1}[.\\-]\\d{3}\\.\\d{3}$|^\\d{15}$",
    IsTaxIdSupported: "true",
    IsTaxIdOptional: "true",
    TaxIdFormat: "12.123.123.1.123.123",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "62",
    PaymentTerm: "60",
  },
  IE: {
    ExtensionData: null,
    Iso2Code: "IE",
    Iso3Code: "IRL",
    DefaultCulture: "en-IE",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-IE", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^IE\\d{7}[A-Z]{1,2}$|^IE\\d[A-Z]\\d{5}[A-Z]$|^IE\\d\\W\\d{5}[A-Z]$|^EU",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "IE#######x",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "353",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  IL: {
    ExtensionData: null,
    Iso2Code: "IL",
    Iso3Code: "ISR",
    DefaultCulture: "he-IL",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "he"],
    SupportedCultures: ["he-IL", "en-US"],
    PostalCodeRegex: "^\\d{5}$|^\\d{7}?$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "972",
    PaymentTerm: "60",
  },
  IT: {
    ExtensionData: null,
    Iso2Code: "IT",
    Iso3Code: "ITA",
    DefaultCulture: "it-IT",
    States: [
      "Agrigento",
      "Alessandria",
      "Ancona",
      "Aosta",
      "Arezzo",
      "Ascoli Piceno",
      "Asti",
      "Avellino",
      "Bari",
      "Barletta Andria-Trani",
      "Belluno",
      "Benevento",
      "Bergamo",
      "Biella",
      "Bologna",
      "Bolzano",
      "Brescia",
      "Brindisi",
      "Cagliari",
      "Caltanissetta",
      "Campobasso",
      "Carbonia-Iglesias",
      "Caserta",
      "Catania",
      "Catanzaro",
      "Chieti",
      "Como",
      "Cosenza",
      "Cremona",
      "Crotone",
      "Cuneo",
      "Enna",
      "Fermo",
      "Ferrara",
      "Firenze",
      "Foggia",
      "Forl\u00ec Cesena",
      "Frosinone",
      "Genova",
      "Gorizia",
      "Grosseto",
      "Imperia",
      "Isernia",
      "La Spezia",
      "L'Aquila",
      "Latina",
      "Lecce",
      "Lecco",
      "Livorno",
      "Lodi",
      "Lucca",
      "Macerata",
      "Mantua",
      "Massa-Carrara",
      "Matera",
      "Medio Campidano",
      "Messina",
      "Milano",
      "Modena",
      "Monza e Brianza",
      "Napoli",
      "Novara",
      "Nuoro",
      "Ogliastra",
      "Olbia-Tempio",
      "Oristano",
      "Padua",
      "Palermo",
      "Parma",
      "Pavia",
      "Perugia",
      "Pesaro e Urbino",
      "Pescara",
      "Piacenza",
      "Pisa",
      "Pistoia",
      "Pordenone",
      "Potenza",
      "Prato",
      "Ragusa",
      "Ravenna",
      "Reggio Calabria",
      "Reggio Emilia",
      "Rieti",
      "Rimini",
      "Roma",
      "Rovigo",
      "Salerno",
      "Sassari",
      "Savona",
      "Siena",
      "Sondrio",
      "Syracuse",
      "Taranto",
      "Teramo",
      "Terni",
      "Torino",
      "Trapani",
      "Trento",
      "Treviso",
      "Trieste",
      "Udine",
      "Varese",
      "Venezia",
      "Verbano-Cusio-Ossola",
      "Vercelli",
      "Verona",
      "Vibo Valentia",
      "Vicenza",
      "Viterbo",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["en", "it"],
    SupportedCultures: ["it-IT", "en-US"],
    PostalCodeRegex: "^(([0-358]9)|([0-589]8)|([0-9][0-7]))[0-9]{3}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^IT[\\d]{11,11}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "IT###########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "39",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  CI: {
    ExtensionData: null,
    Iso2Code: "CI",
    Iso3Code: "CIV",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "fr"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "225",
    PaymentTerm: "60",
  },
  JM: {
    ExtensionData: null,
    Iso2Code: "JM",
    Iso3Code: "JAM",
    DefaultCulture: "en-JM",
    States: [
      "Clarendon",
      "Hanover",
      "Kingston",
      "Manchester",
      "Portland",
      "Saint Andrew",
      "Saint Ann",
      "Saint Catherine",
      "Saint Elizabeth",
      "Saint James",
      "Saint Mary",
      "Saint Thomas",
      "Trelawny",
      "Westmoreland",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-JM", "en-US"],
    PostalCodeRegex: "^[0-9A-Za-z]{0,5}$",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1876",
    PaymentTerm: "60",
  },
  JP: {
    ExtensionData: null,
    Iso2Code: "JP",
    Iso3Code: "JPN",
    DefaultCulture: "ja-JP",
    States: [
      "Aichi-ken",
      "Akita-ken",
      "Aomori-ken",
      "Chiba-ken",
      "Ehime-ken",
      "Fukui-ken",
      "Fukuoka-ken",
      "Fukushima-ken",
      "Gifu-ken",
      "Gunma-ken",
      "Hiroshima-ken",
      "Hokkaido",
      "Hyogo-ken",
      "Ibaraki-ken",
      "Ishikawa-ken",
      "Iwate-ken",
      "Kagawa-ken",
      "Kagoshima-ken",
      "Kanagawa-ken",
      "Kochi-ken",
      "Kumamoto-ken",
      "Kyoto-fu",
      "Mie-ken",
      "Miyagi-ken",
      "Miyazaki-ken",
      "Nagano-ken",
      "Nagasaki-ken",
      "Nara-ken",
      "Niigata-ken",
      "Oita-ken",
      "Okayama-ken",
      "Okinawa-ken",
      "Osaka-fu",
      "Saga-ken",
      "Saitama-ken",
      "Shiga-ken",
      "Shimane-ken",
      "Shizuoka-ken",
      "Tochigi-ken",
      "Tokushima-ken",
      "Tokyo-to",
      "Tottori-ken",
      "Toyama-ken",
      "Wakayama-ken",
      "Yamagata-ken",
      "Yamaguchi-ken",
      "Yamanashi-ken",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["ja", "en"],
    SupportedCultures: ["ja-JP", "en-US"],
    PostalCodeRegex: "^[0-9]{3,3}[-]?[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "Japan",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "81",
    PaymentTerm: "60",
    SalesTerritory: "Japan",

    IsSalesTerritoryRequired: "true",
  },
  KZ: {
    ExtensionData: null,
    Iso2Code: "KZ",
    Iso3Code: "KAZ",
    DefaultCulture: "kk-KZ",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["ru", "en", "kk"],
    SupportedCultures: ["kk-KZ", "en-US"],
    PostalCodeRegex: "^[a-zA-Z0-9]{6,7}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "7",
    PaymentTerm: "60",
  },
  JO: {
    ExtensionData: null,
    Iso2Code: "JO",
    Iso3Code: "JOR",
    DefaultCulture: "ar-JO",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "ar"],
    SupportedCultures: ["ar-JO", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "962",
    PaymentTerm: "60",
  },
  KE: {
    ExtensionData: null,
    Iso2Code: "KE",
    Iso3Code: "KEN",
    DefaultCulture: "sw-KE",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["sw-KE", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^P\\d{9}[A-Za-z]$",
    TaxIdFormat: "P052005205K",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "254",
    PaymentTerm: "60",
  },
  KR: {
    ExtensionData: null,
    Iso2Code: "KR",
    Iso3Code: "KOR",
    DefaultCulture: "ko-KR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["ko", "en"],
    SupportedCultures: ["ko-KR", "en-US"],
    PostalCodeRegex: "^[0-9]{3,3}[-]?[0-9]{3,3}$|^[0-9]{5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\d{3}\\-\\d{2}\\-\\d{5}$|^\\d{10}$",
    IsTaxIdOptional: "false",
    TaxIdSample: "1234567890",
    TaxIdFormat: "##########",
    IsRegistrationNumberSupported: "true",
    ResellerAgreementRegion: "Korea",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "82",
    PaymentTerm: "60",
    SalesTerritory: "Korea",

    IsSalesTerritoryRequired: "true",
  },
  KW: {
    ExtensionData: null,
    Iso2Code: "KW",
    Iso3Code: "KWT",
    DefaultCulture: "ar-KW",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "ar"],
    SupportedCultures: ["ar-KW", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "965",
    PaymentTerm: "60",
    SalesTerritory: "Kuwait",

    IsSalesTerritoryRequired: "true",
  },
  KG: {
    ExtensionData: null,
    Iso2Code: "KG",
    Iso3Code: "KGZ",
    DefaultCulture: "ky-KG",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "ru"],
    SupportedCultures: ["ky-KG", "en-US"],
    PostalCodeRegex: "^[0-9]{6,6}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "996",
    PaymentTerm: "60",
  },
  LA: {
    ExtensionData: null,
    Iso2Code: "LA",
    Iso3Code: "LAO",
    DefaultCulture: "lo-LA",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["lo-LA", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "856",
    PaymentTerm: "60",
  },
  LB: {
    ExtensionData: null,
    Iso2Code: "LB",
    Iso3Code: "LBN",
    DefaultCulture: "ar-LB",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "fr", "ar"],
    SupportedCultures: ["ar-LB", "en-US"],
    PostalCodeRegex: "^[0-9]{8,8}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "961",
    PaymentTerm: "60",
  },
  LS: {
    ExtensionData: null,
    Iso2Code: "LS",
    Iso3Code: "LSO",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "266",
    PaymentTerm: "60",
  },
  LV: {
    ExtensionData: null,
    Iso2Code: "LV",
    Iso3Code: "LVA",
    DefaultCulture: "lv-LV",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "lv"],
    SupportedCultures: ["lv-LV", "en-US"],
    PostalCodeRegex: "^([Ll][Vv]-?)?[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^LV[\\d]{11,11}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "LV###########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "371",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  LR: {
    ExtensionData: null,
    Iso2Code: "LR",
    Iso3Code: "LBR",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "231",
    PaymentTerm: "60",
  },
  LY: {
    ExtensionData: null,
    Iso2Code: "LY",
    Iso3Code: "LBY",
    DefaultCulture: "ar-LY",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "ar"],
    SupportedCultures: ["ar-LY", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "218",
    PaymentTerm: "60",
  },
  LI: {
    ExtensionData: null,
    Iso2Code: "LI",
    Iso3Code: "LIE",
    DefaultCulture: "de-LI",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["de", "en"],
    SupportedCultures: ["de-LI", "en-US"],
    PostalCodeRegex: "^[1-9][0-9]{3,3}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\d{2}\\s\\d{3}$|^\\d{5}$",
    IsTaxIdOptional: "true",
    TaxIdFormat: "#####",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "423",
    PaymentTerm: "60",
  },
  LT: {
    ExtensionData: null,
    Iso2Code: "LT",
    Iso3Code: "LTU",
    DefaultCulture: "lt-LT",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["lt", "en"],
    SupportedCultures: ["lt-LT", "en-US"],
    PostalCodeRegex: "^([lL][tT]-?)?[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^LT(([\\d]{9,9})|([\\d]{12,12}))$",
    TaxIdFormat: "LT############",
    IsRegistrationNumberSupported: "false",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "370",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  LU: {
    ExtensionData: null,
    Iso2Code: "LU",
    Iso3Code: "LUX",
    DefaultCulture: "fr-LU",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "fr", "de"],
    SupportedCultures: ["de-LU", "fr-LU", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^LU[\\d]{8,8}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "LU########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "352",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  MO: {
    ExtensionData: null,
    Iso2Code: "MO",
    Iso3Code: "MAC",
    DefaultCulture: "zh-MO",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "zh-CHT"],
    SupportedCultures: ["zh-MO", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "853",
    PaymentTerm: "60",
  },
  MF: {
    ExtensionData: null,
    Iso2Code: "MF",
    Iso3Code: "MAF",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "590",
    PaymentTerm: "60",
  },
  MG: {
    ExtensionData: null,
    Iso2Code: "MG",
    Iso3Code: "MDG",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "261",
    PaymentTerm: "60",
  },
  MW: {
    ExtensionData: null,
    Iso2Code: "MW",
    Iso3Code: "MWI",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "265",
    PaymentTerm: "60",
  },
  MY: {
    ExtensionData: null,
    Iso2Code: "MY",
    Iso3Code: "MYS",
    DefaultCulture: "en-MY",
    States: [
      "Federal Territory of Kuala Lumpur",
      "Federal Territory of Labuan",
      "Federal Territory of Putrajaya",
      "Johor",
      "Kedah",
      "Kelantan",
      "Melaka",
      "Negeri Sembilan",
      "Pahang",
      "Perak",
      "Perlis",
      "Pulau Pinang",
      "Sabah",
      "Sarawak",
      "Selangor",
      "Terengganu",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["en", "ms"],
    SupportedCultures: ["en-MY", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^[A-Z]\\d{2}-?\\d{4}-?\\d{8}$",
    IsTaxIdSupported: "false",
    IsTaxIdOptional: "true",
    TaxIdFormat: "A12-1234-12345678",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "60",
    PaymentTerm: "60",
    SalesTerritory: "Malaysia",

    IsSalesTerritoryRequired: "true",
  },
  MV: {
    ExtensionData: null,
    Iso2Code: "MV",
    Iso3Code: "MDV",
    DefaultCulture: "dv-MV",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["dv-MV", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "960",
    PaymentTerm: "60",
  },
  ML: {
    ExtensionData: null,
    Iso2Code: "ML",
    Iso3Code: "MLI",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "223",
    PaymentTerm: "60",
  },
  MT: {
    ExtensionData: null,
    Iso2Code: "MT",
    Iso3Code: "MLT",
    DefaultCulture: "mt-MT",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["mt-MT", "en-US"],
    PostalCodeRegex: "^[a-zA-Z]{3,3}[ ][0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^MT[\\d]{8,8}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "MT########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "356",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  MQ: {
    ExtensionData: null,
    Iso2Code: "MQ",
    Iso3Code: "MTQ",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr"],
    SupportedCultures: "fr-FR",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "596",
    PaymentTerm: "60",
  },
  MR: {
    ExtensionData: null,
    Iso2Code: "MR",
    Iso3Code: "MRT",
    DefaultCulture: "ar-SA",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["ar-SA", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "222",
    PaymentTerm: "60",
  },
  MU: {
    ExtensionData: null,
    Iso2Code: "MU",
    Iso3Code: "MUS",
    DefaultCulture: "en-GB",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-GB", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "230",
    PaymentTerm: "60",
  },
  MX: {
    ExtensionData: null,
    Iso2Code: "MX",
    Iso3Code: "MEX",
    DefaultCulture: "es-MX",
    States: [
      "AG",
      "BC",
      "BS",
      "CM",
      "CS",
      "CH",
      "CO",
      "CL",
      "DF",
      "DG",
      "MX",
      "GT",
      "GR",
      "HG",
      "JA",
      "MI",
      "MO",
      "NA",
      "NL",
      "OA",
      "PU",
      "QT",
      "QR",
      "SL",
      "SI",
      "SO",
      "TB",
      "TM",
      "TL",
      "VE",
      "YU",
      "ZA",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["en", "es"],
    SupportedCultures: ["es-MX", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^[A-Z&]{3,4}-?\\d{6}-?\\w{3}$",
    IsTaxIdSupported: "false",
    IsTaxIdOptional: "true",
    TaxIdFormat: "ABC-123456-abc",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "52",
    PaymentTerm: "60",
    SalesTerritory: "Mexico",

    IsSalesTerritoryRequired: "true",
  },
  MC: {
    ExtensionData: null,
    Iso2Code: "MC",
    Iso3Code: "MCO",
    DefaultCulture: "fr-MC",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "fr"],
    SupportedCultures: ["fr-MC", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^FR[A-Z0-9]{2}\\d{9}$|^EU",
    IsTaxIdOptional: "true",
    TaxIdFormat: "FR###########",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "377",
    PaymentTerm: "60",
  },
  MN: {
    ExtensionData: null,
    Iso2Code: "MN",
    Iso3Code: "MNG",
    DefaultCulture: "mn-MN",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["mn-MN", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "976",
    PaymentTerm: "60",
  },
  MD: {
    ExtensionData: null,
    Iso2Code: "MD",
    Iso3Code: "MDA",
    DefaultCulture: "ro-RO",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "ro"],
    SupportedCultures: ["ro-RO", "en-US"],
    PostalCodeRegex: "^(MD[ \\-])?[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{7}$",
    TaxIdFormat: "1234567",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "373",
    PaymentTerm: "60",
  },
  ME: {
    ExtensionData: null,
    Iso2Code: "ME",
    Iso3Code: "MNE",
    DefaultCulture: "sr-Latn-ME",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["sr-Latn-CS", "en", "sr-Cyrl"],
    SupportedCultures: ["sr-Latn-ME", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "382",
    PaymentTerm: "60",
  },
  MS: {
    ExtensionData: null,
    Iso2Code: "MS",
    Iso3Code: "MSR",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  MA: {
    ExtensionData: null,
    Iso2Code: "MA",
    Iso3Code: "MAR",
    DefaultCulture: "ar-MA",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en", "ar"],
    SupportedCultures: ["ar-MA", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "212",
    PaymentTerm: "60",
  },
  MM: {
    ExtensionData: null,
    Iso2Code: "MM",
    Iso3Code: "MMR",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "95",
    PaymentTerm: "60",
  },
  MZ: {
    ExtensionData: null,
    Iso2Code: "MZ",
    Iso3Code: "MOZ",
    DefaultCulture: "pt-PT",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["pt"],
    SupportedCultures: "pt-PT",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "258",
    PaymentTerm: "60",
  },
  OM: {
    ExtensionData: null,
    Iso2Code: "OM",
    Iso3Code: "OMN",
    DefaultCulture: "ar-OM",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "ar"],
    SupportedCultures: ["ar-OM", "en-US"],
    PostalCodeRegex: "^[0-9]{3,3}$",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^OM\\d{10}$",
    TaxIdFormat: "OM1234567890",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "968",
    PaymentTerm: "60",
    SalesTerritory: "Oman",

    IsSalesTerritoryRequired: "true",
  },
  NA: {
    ExtensionData: null,
    Iso2Code: "NA",
    Iso3Code: "NAM",
    DefaultCulture: "en-GB",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-GB", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "264",
    PaymentTerm: "60",
  },
  NR: {
    ExtensionData: null,
    Iso2Code: "NR",
    Iso3Code: "NRU",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "674",
    PaymentTerm: "60",
  },
  NP: {
    ExtensionData: null,
    Iso2Code: "NP",
    Iso3Code: "NPL",
    DefaultCulture: "ne-NP",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["ne-NP", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\d{9}$",
    IsTaxIdSupported: "false",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "977",
    PaymentTerm: "60",
  },
  NL: {
    ExtensionData: null,
    Iso2Code: "NL",
    Iso3Code: "NLD",
    DefaultCulture: "nl-NL",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "nl"],
    SupportedCultures: ["nl-NL", "en-US"],
    PostalCodeRegex: "^[1-9][0-9]{3,3}[ ]?[a-zA-Z]{2,2}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^NL[\\d]{9,9}B[\\d]{2,2}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "NL#########B##",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "31",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  AN: {
    ExtensionData: null,
    Iso2Code: "AN",
    Iso3Code: "ANT",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: null,
    GeographicRegion: null,
    CountryCallingCodes: null,
    PaymentTerm: "60",
  },
  AW: {
    ExtensionData: null,
    Iso2Code: "AW",
    Iso3Code: "ABW",
    DefaultCulture: "nl-NL",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["nl"],
    SupportedCultures: ["nl-NL", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "297",
    PaymentTerm: "60",
  },
  NC: {
    ExtensionData: null,
    Iso2Code: "NC",
    Iso3Code: "NCL",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "687",
    PaymentTerm: "60",
  },
  VU: {
    ExtensionData: null,
    Iso2Code: "VU",
    Iso3Code: "VUT",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "678",
    PaymentTerm: "60",
  },
  NZ: {
    ExtensionData: null,
    Iso2Code: "NZ",
    Iso3Code: "NZL",
    DefaultCulture: "en-NZ",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-NZ", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\d{2,3}-?\\d{3}-?\\d{3}$",
    IsRegistrationNumberSupported: "false",
    IsTaxIdSupported: "false",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "64",
    PaymentTerm: "60",
    SalesTerritory: "New Zealand",

    IsSalesTerritoryRequired: "true",
  },
  NI: {
    ExtensionData: null,
    Iso2Code: "NI",
    Iso3Code: "NIC",
    DefaultCulture: "es-NI",
    States: [
      "Atl\u00e1ntico Norte",
      "Atl\u00e1ntico Sur",
      "Boaco",
      "Carazo",
      "Chinandega",
      "Chontales",
      "Estel\u00ed",
      "Granada",
      "Jinotega",
      "Le\u00f3n",
      "Madriz",
      "Managua",
      "Masaya",
      "Matagalpa",
      "Nueva Segovia",
      "R\u00edo San Juan",
      "Rivas",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["en", "es"],
    SupportedCultures: ["es-NI", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "505",
    PaymentTerm: "60",
  },
  NE: {
    ExtensionData: null,
    Iso2Code: "NE",
    Iso3Code: "NER",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "227",
    PaymentTerm: "60",
  },
  NG: {
    ExtensionData: null,
    Iso2Code: "NG",
    Iso3Code: "NGA",
    DefaultCulture: "ha-Latn-NG",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["ha-Latn-NG", "en-US"],
    PostalCodeRegex: "^[0-9]{6,6}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{8}-0001$",
    TaxIdFormat: "01012345-0001",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "234",
    PaymentTerm: "60",
  },
  NU: {
    ExtensionData: null,
    Iso2Code: "NU",
    Iso3Code: "NIU",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "683",
    PaymentTerm: "60",
  },
  NF: {
    ExtensionData: null,
    Iso2Code: "NF",
    Iso3Code: "NFK",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "672",
    PaymentTerm: "60",
  },
  NO: {
    ExtensionData: null,
    Iso2Code: "NO",
    Iso3Code: "NOR",
    DefaultCulture: "nb-NO",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "no"],
    SupportedCultures: ["nb-NO", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^(NO)?\\s?\\d{3}\\s?\\d{3}\\s?\\d{3}\\s?MVA$",
    IsTaxIdOptional: "true",
    TaxIdSample: "NO123123123MVA",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "47",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  MP: {
    ExtensionData: null,
    Iso2Code: "MP",
    Iso3Code: "MNP",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  UM: {
    ExtensionData: null,
    Iso2Code: "UM",
    Iso3Code: "UMI",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  FM: {
    ExtensionData: null,
    Iso2Code: "FM",
    Iso3Code: "FSM",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "691",
    PaymentTerm: "60",
  },
  MH: {
    ExtensionData: null,
    Iso2Code: "MH",
    Iso3Code: "MHL",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "692",
    PaymentTerm: "60",
  },
  PW: {
    ExtensionData: null,
    Iso2Code: "PW",
    Iso3Code: "PLW",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "680",
    PaymentTerm: "60",
  },
  PK: {
    ExtensionData: null,
    Iso2Code: "PK",
    Iso3Code: "PAK",
    DefaultCulture: "ur-PK",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["ur-PK", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "92",
    PaymentTerm: "60",
  },
  PA: {
    ExtensionData: null,
    Iso2Code: "PA",
    Iso3Code: "PAN",
    DefaultCulture: "es-PA",
    States: [
      "Bocas del Toro",
      "Chiriqu\u00ed",
      "Cocl\u00e9",
      "Col\u00f3n",
      "Dari\u00e9n",
      "Ember\u00e1",
      "Herrera",
      "Kuna Yala",
      "Los Santos",
      "Ng\u00e4be Bugl\u00e9",
      "Panam\u00e1",
      "Panama Oeste",
      "Veraguas",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["es", "en"],
    SupportedCultures: ["es-PA", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "507",
    PaymentTerm: "60",
  },
  PG: {
    ExtensionData: null,
    Iso2Code: "PG",
    Iso3Code: "PNG",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "675",
    PaymentTerm: "60",
  },
  PY: {
    ExtensionData: null,
    Iso2Code: "PY",
    Iso3Code: "PRY",
    DefaultCulture: "es-PY",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["es", "en"],
    SupportedCultures: ["es-PY", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "595",
    PaymentTerm: "60",
  },
  PE: {
    ExtensionData: null,
    Iso2Code: "PE",
    Iso3Code: "PER",
    DefaultCulture: "es-PE",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "es"],
    SupportedCultures: ["es-PE", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "51",
    PaymentTerm: "60",
  },
  PH: {
    ExtensionData: null,
    Iso2Code: "PH",
    Iso3Code: "PHL",
    DefaultCulture: "en-PH",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-PH", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\d{3}\\-\\d{3}\\-\\d{3}$|^\\d{3}\\-\\d{3}\\-\\d{3}\\-\\d{3}$",
    IsTaxIdSupported: "true",
    IsTaxIdOptional: "true",
    TaxIdFormat: "123-456-789; 123-456-789-012",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "63",
    PaymentTerm: "60",
    SalesTerritory: "Philippines",

    IsSalesTerritoryRequired: "true",
  },
  PN: {
    ExtensionData: null,
    Iso2Code: "PN",
    Iso3Code: "PCN",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "64",
    PaymentTerm: "60",
  },
  PL: {
    ExtensionData: null,
    Iso2Code: "PL",
    Iso3Code: "POL",
    DefaultCulture: "pl-PL",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "pl"],
    SupportedCultures: ["pl-PL", "en-US"],
    PostalCodeRegex: "^[0-9]{2,2}[-][0-9]{3,3}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^PL[\\d]{10,10}$",
    IsRegistrationNumberSupported: "false",
    TaxIdSample: "PL5262967763",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "48",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  PT: {
    ExtensionData: null,
    Iso2Code: "PT",
    Iso3Code: "PRT",
    DefaultCulture: "pt-PT",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "pt-PT"],
    SupportedCultures: ["pt-PT", "en-US"],
    PostalCodeRegex: "^\\d{4}(-\\d{3})?$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^PT[\\d]{9,9}$",
    IsRegistrationNumberSupported: "false",
    TaxIdSample: "PT980152267",
    TaxIdFormat: "PT#########",
    IsTaxIdOptional: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "351",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  GW: {
    ExtensionData: null,
    Iso2Code: "GW",
    Iso3Code: "GNB",
    DefaultCulture: "pt-PT",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["pt", "en"],
    SupportedCultures: ["pt-PT", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "245",
    PaymentTerm: "60",
  },
  TL: {
    ExtensionData: null,
    Iso2Code: "TL",
    Iso3Code: "TLS",
    DefaultCulture: "pt-PT",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["pt"],
    SupportedCultures: ["pt-PT", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "670",
    PaymentTerm: "60",
  },
  PR: {
    ExtensionData: null,
    Iso2Code: "PR",
    Iso3Code: "PRI",
    DefaultCulture: "es-PR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "es"],
    SupportedCultures: ["es-PR", "en-US"],
    PostalCodeRegex: "(^[0-9]{5,5}[-]?[0-9]{4,4}$)|(^[0-9]{5,5}$)",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\d{7}(-|\\s)?\\d{4}",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
    SalesTerritory: "PR",

    IsSalesTerritoryRequired: "true",
  },
  QA: {
    ExtensionData: null,
    Iso2Code: "QA",
    Iso3Code: "QAT",
    DefaultCulture: "ar-QA",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "ar"],
    SupportedCultures: ["ar-QA", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "974",
    PaymentTerm: "60",
    SalesTerritory: "Qatar",

    IsSalesTerritoryRequired: "true",
  },
  RE: {
    ExtensionData: null,
    Iso2Code: "RE",
    Iso3Code: "REU",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "262",
    PaymentTerm: "60",
  },
  RO: {
    ExtensionData: null,
    Iso2Code: "RO",
    Iso3Code: "ROU",
    DefaultCulture: "ro-RO",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "ro"],
    SupportedCultures: ["ro-RO", "en-US"],
    PostalCodeRegex: "^[0-9]{6,6}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^RO[\\d]{2,10}$",
    IsRegistrationNumberSupported: "false",
    TaxIdSample: "RO31002907",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "40",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  RU: {
    ExtensionData: null,
    Iso2Code: "RU",
    Iso3Code: "RUS",
    DefaultCulture: "ru-RU",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["ru", "en"],
    SupportedCultures: ["ru-RU", "en-US"],
    PostalCodeRegex: "^[0-9]{6,6}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "7",
    PaymentTerm: "60",
  },
  RW: {
    ExtensionData: null,
    Iso2Code: "RW",
    Iso3Code: "RWA",
    DefaultCulture: "rw-RW",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "fr"],
    SupportedCultures: ["rw-RW", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "250",
    PaymentTerm: "60",
  },
  SH: {
    ExtensionData: null,
    Iso2Code: "SH",
    Iso3Code: "SHN",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: ["290", "247"],
    PaymentTerm: "60",
  },
  KN: {
    ExtensionData: null,
    Iso2Code: "KN",
    Iso3Code: "KNA",
    DefaultCulture: "en-GB",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-GB", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1869",
    PaymentTerm: "60",
  },
  AI: {
    ExtensionData: null,
    Iso2Code: "AI",
    Iso3Code: "AIA",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  LC: {
    ExtensionData: null,
    Iso2Code: "LC",
    Iso3Code: "LCA",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  PM: {
    ExtensionData: null,
    Iso2Code: "PM",
    Iso3Code: "SPM",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "508",
    PaymentTerm: "60",
  },
  VC: {
    ExtensionData: null,
    Iso2Code: "VC",
    Iso3Code: "VCT",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  SM: {
    ExtensionData: null,
    Iso2Code: "SM",
    Iso3Code: "SMR",
    DefaultCulture: "it-IT",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["it"],
    SupportedCultures: ["it-IT", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "WesternEurope",
    CountryCallingCodes: "378",
    PaymentTerm: "60",
  },
  ST: {
    ExtensionData: null,
    Iso2Code: "ST",
    Iso3Code: "STP",
    DefaultCulture: "pt-PT",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["pt", "en"],
    SupportedCultures: ["pt-PT", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "239",
    PaymentTerm: "60",
  },
  SA: {
    ExtensionData: null,
    Iso2Code: "SA",
    Iso3Code: "SAU",
    DefaultCulture: "ar-SA",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "ar"],
    SupportedCultures: ["ar-SA", "en-US"],
    PostalCodeRegex: "(^[0-9]{5,5}$)|(^[0-9]{9,9}$)",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\d{15}$",
    IsTaxIdOptional: "true",
    TaxIdSample: "123456789012345",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: null,
    CountryCallingCodes: "966",
    PaymentTerm: "60",
    SalesTerritory: "Saudi Arabia",

    IsSalesTerritoryRequired: "true",
  },
  SN: {
    ExtensionData: null,
    Iso2Code: "SN",
    Iso3Code: "SEN",
    DefaultCulture: "wo-SN",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "fr"],
    SupportedCultures: ["wo-SN", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "221",
    PaymentTerm: "60",
  },
  SC: {
    ExtensionData: null,
    Iso2Code: "SC",
    Iso3Code: "SYC",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "248",
    PaymentTerm: "60",
  },
  SL: {
    ExtensionData: null,
    Iso2Code: "SL",
    Iso3Code: "SLE",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "232",
    PaymentTerm: "60",
  },
  SG: {
    ExtensionData: null,
    Iso2Code: "SG",
    Iso3Code: "SGP",
    DefaultCulture: "en-SG",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "zh-CHS"],
    SupportedCultures: ["en-SG", "zh-SG", "en-US"],
    PostalCodeRegex: "^[0-9]{6,6}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "false",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\w{2}-?\\d{7}-?\\w$|^\\d{8,9}\\w$|^[TS]\\d{2}[A-Z]\\w\\d{4}\\w$",
    IsTaxIdOptional: "true",
    TaxIdFormat: "ab-1234567-a",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "65",
    PaymentTerm: "60",
    SalesTerritory: "Singapore",

    IsSalesTerritoryRequired: "true",
  },
  SK: {
    ExtensionData: null,
    Iso2Code: "SK",
    Iso3Code: "SVK",
    DefaultCulture: "sk-SK",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["sk", "en"],
    SupportedCultures: ["sk-SK", "en-US"],
    PostalCodeRegex: "^[0-9]{3,3}[ ][0-9]{2,2}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^SK[\\d]{10,10}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "SK##########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "421",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  VN: {
    ExtensionData: null,
    Iso2Code: "VN",
    Iso3Code: "VNM",
    DefaultCulture: "vi-VN",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "vi"],
    SupportedCultures: ["vi-VN", "en-US"],
    PostalCodeRegex: "^[0-9]{6,6}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\d{10}$|^\\d{10}\\-\\d{3}$",
    IsTaxIdSupported: "true",
    IsTaxIdOptional: "true",
    TaxIdFormat: "1234567890; 1234567890-123",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "84",
    PaymentTerm: "60",
    SalesTerritory: "Vietnam",

    IsSalesTerritoryRequired: "true",
  },
  SI: {
    ExtensionData: null,
    Iso2Code: "SI",
    Iso3Code: "SVN",
    DefaultCulture: "sl-SI",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["sl", "en"],
    SupportedCultures: ["sl-SI", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^SI[\\d]{8,8}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "SI########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "386",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  ZA: {
    ExtensionData: null,
    Iso2Code: "ZA",
    Iso3Code: "ZAF",
    DefaultCulture: "en-ZA",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-ZA", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\d{10}$|^\\d{3}\\s\\d{4}\\s\\d{3}$",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: null,
    CountryCallingCodes: "27",
    PaymentTerm: "60",
    SalesTerritory: "South Africa",

    IsSalesTerritoryRequired: "true",
  },
  ZW: {
    ExtensionData: null,
    Iso2Code: "ZW",
    Iso3Code: "ZWE",
    DefaultCulture: "en-ZW",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-ZW", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{8}$",
    TaxIdFormat: "12345678",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "263",
    PaymentTerm: "60",
  },
  ES: {
    ExtensionData: null,
    Iso2Code: "ES",
    Iso3Code: "ESP",
    DefaultCulture: "es-ES",
    States: [
      "\u00c1lava",
      "Albacete",
      "Alicante",
      "Almer\u00eda",
      "Asturias",
      "\u00c1vila",
      "Badajoz",
      "Baleares",
      "Barcelona",
      "Burgos",
      "C\u00e1ceres",
      "C\u00e1diz",
      "Cantabria",
      "Castell\u00f3n",
      "Ceuta",
      "Ciudad Real",
      "C\u00f3rdoba",
      "Cuenca",
      "Girona",
      "Granada",
      "Guadalajara",
      "Guip\u00fazcoa",
      "Huelva",
      "Huesca",
      "Ja\u00e9n",
      "La Coru\u00f1a",
      "La Rioja",
      "Las Palmas",
      "Le\u00f3n",
      "Lleida",
      "Lugo",
      "Madrid",
      "M\u00e1laga",
      "Melilla",
      "Murcia",
      "Navarra",
      "Orense",
      "Palencia",
      "Pontevedra",
      "Salamanca",
      "Santa Cruz de Tenerife",
      "Segovia",
      "Sevilla",
      "Soria",
      "Tarragona",
      "Teruel",
      "Toledo",
      "Valencia",
      "Valladolid",
      "Vizcaya",
      "Zamora",
      "Zaragoza",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["en", "es", "ca", "eu", "gl"],
    SupportedCultures: ["es-ES", "ca-ES", "eu-ES", "gl-ES", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^ES([A-Z][\\d]{7,7}[A-Z0-9]|[\\d]{8,8}[A-Z])$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "ESx#######_",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "34",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  SR: {
    ExtensionData: null,
    Iso2Code: "SR",
    Iso3Code: "SUR",
    DefaultCulture: "nl-NL",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["nl"],
    SupportedCultures: ["nl-NL", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "597",
    PaymentTerm: "60",
  },
  SJ: {
    ExtensionData: null,
    Iso2Code: "SJ",
    Iso3Code: "SJM",
    DefaultCulture: "nb-NO",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["nb", "en"],
    SupportedCultures: ["nb-NO", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsTaxIdOptional: "true",
    IsVatIdSupported: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "WesternEurope",
    CountryCallingCodes: "47",
    PaymentTerm: "60",
  },
  SZ: {
    ExtensionData: null,
    Iso2Code: "SZ",
    Iso3Code: "SWZ",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "268",
    PaymentTerm: "60",
  },
  SE: {
    ExtensionData: null,
    Iso2Code: "SE",
    Iso3Code: "SWE",
    DefaultCulture: "sv-SE",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "sv"],
    SupportedCultures: ["sv-SE", "en-US"],
    PostalCodeRegex: "^(3[013-9]|4[0-7]|9[0-8]|[125-8][0-9])[0-9][ ]{1,1}[0-9]{2,2}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^SE[\\d]{12,12}$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "SE############",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "46",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  CH: {
    ExtensionData: null,
    Iso2Code: "CH",
    Iso3Code: "CHE",
    DefaultCulture: "de-CH",
    States: [
      "Aargau",
      "Appenzell-Ausserrhoden",
      "Appenzell-Innerrhoden",
      "Basel-Landschaft",
      "Basel-Stadt",
      "Bern",
      "Fribourg",
      "Geneva",
      "Glarus",
      "Graub\u00fcnden",
      "Jura",
      "Lucerne",
      "Neuch\u00e2tel",
      "Nidwalden",
      "Obwalden",
      "Schaffhausen",
      "Schwyz",
      "Solothurn",
      "St. Gallen",
      "Thurgau",
      "Ticino",
      "Uri",
      "Valais",
      "Vaud",
      "Zug",
      "Z\u00fcrich",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["en", "de", "fr", "it"],
    SupportedCultures: ["de-CH", "fr-CH", "it-CH", "en-US"],
    PostalCodeRegex: "^[1-9][0-9]{3,3}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex:
      "^(CH)?\\d{3}(\\s)?\\d{3}$|^CHE-?\\d{3}\\.?\\d{3}\\.?\\d{3}(\\s)?(((HR/?)?MWST)|((RC/?)?(TVA|IVA)))?$",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "41",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  TJ: {
    ExtensionData: null,
    Iso2Code: "TJ",
    Iso3Code: "TJK",
    DefaultCulture: "tg-Cyrl-TJ",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["ru", "en"],
    SupportedCultures: ["tg-Cyrl-TJ", "en-US"],
    PostalCodeRegex: "^[0-9]{6}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{9}$",
    TaxIdFormat: "123456789",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "992",
    PaymentTerm: "60",
  },
  TH: {
    ExtensionData: null,
    Iso2Code: "TH",
    Iso3Code: "THA",
    DefaultCulture: "th-TH",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["th", "en"],
    SupportedCultures: ["th-TH", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\d{13}$",
    IsTaxIdSupported: "false",
    IsTaxIdOptional: "true",
    TaxIdSample: "123457890123",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "66",
    PaymentTerm: "60",
    SalesTerritory: "Thailand",

    IsSalesTerritoryRequired: "true",
  },
  TG: {
    ExtensionData: null,
    Iso2Code: "TG",
    Iso3Code: "TGO",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "228",
    PaymentTerm: "60",
  },
  TK: {
    ExtensionData: null,
    Iso2Code: "TK",
    Iso3Code: "TKL",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "690",
    PaymentTerm: "60",
  },
  TO: {
    ExtensionData: null,
    Iso2Code: "TO",
    Iso3Code: "TON",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "676",
    PaymentTerm: "60",
  },
  TT: {
    ExtensionData: null,
    Iso2Code: "TT",
    Iso3Code: "TTO",
    DefaultCulture: "en-TT",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-TT", "en-US"],
    PostalCodeRegex: "^[0-9]{6,6}$",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  AE: {
    ExtensionData: null,
    Iso2Code: "AE",
    Iso3Code: "ARE",
    DefaultCulture: "ar-AE",
    States: ["AZ", "AJ", "FU", "SH", "DU", "RK", "UQ"],

    IsStateRequired: "true",
    SupportedLanguages: ["en", "ar"],
    SupportedCultures: ["ar-AE", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\d{15}$",
    IsTaxIdOptional: "true",
    TaxIdSample: "123456789012345",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "971",
    PaymentTerm: "60",
    SalesTerritory: "UAE",

    IsSalesTerritoryRequired: "true",
  },
  TN: {
    ExtensionData: null,
    Iso2Code: "TN",
    Iso3Code: "TUN",
    DefaultCulture: "ar-TN",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en", "ar"],
    SupportedCultures: ["ar-TN", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "216",
    PaymentTerm: "60",
  },
  TR: {
    ExtensionData: null,
    Iso2Code: "TR",
    Iso3Code: "TUR",
    DefaultCulture: "tr-TR",
    States: [
      "Adana",
      "Adiyaman",
      "Afyonkarahisar",
      "Agri",
      "Aksaray",
      "Amasya",
      "Ankara",
      "Antalya",
      "Ardahan",
      "Artvin",
      "Aydin",
      "Balikesir",
      "Bartin",
      "Batman",
      "Bayburt",
      "Bilecik",
      "Bing\u00f6l",
      "Bitlis",
      "Bolu",
      "Burdur",
      "Bursa",
      "\u00c7anakkale",
      "\u00c7ankiri",
      "\u00c7orum",
      "Denizli",
      "Diyarbakir",
      "D\u00fczce",
      "Edirne",
      "Elazig",
      "Erzincan",
      "Erzurum",
      "Eskisehir",
      "Gaziantep",
      "Giresun",
      "G\u00fcm\u00fcshane",
      "Hakk\u00e2ri",
      "Hatay",
      "Igdir",
      "Isparta",
      "Istanbul",
      "Izmir",
      "Kahramanmara\u015f",
      "Karab\u00fck",
      "Karaman",
      "Kars",
      "Kastamonu",
      "Kayseri",
      "Kilis",
      "Kirikkale",
      "Kirklareli",
      "Kirsehir",
      "Kocaeli",
      "Konya",
      "K\u00fctahya",
      "Malatya",
      "Manisa",
      "Mardin",
      "Mersin",
      "Mugla",
      "Mus",
      "Nevsehir",
      "Nigde",
      "Ordu",
      "Osmaniye",
      "Rize",
      "Sakarya",
      "Samsun",
      "Sanliurfa",
      "Siirt",
      "Sinop",
      "Sirnak",
      "Sivas",
      "Tekirdag",
      "Tokat",
      "Trabzon",
      "Tunceli",
      "Usak",
      "Van",
      "Yalova",
      "Yozgat",
      "Zonguldak",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["tr", "en"],
    SupportedCultures: ["tr-TR", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^\\d{10}$|^\\d{3}\\s\\d{3}\\s\\d{4}$|^\\d{11}$",
    IsTaxIdOptional: "true",
    TaxIdSample: "1234567890",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: null,
    CountryCallingCodes: "90",
    PaymentTerm: "60",
  },
  TM: {
    ExtensionData: null,
    Iso2Code: "TM",
    Iso3Code: "TKM",
    DefaultCulture: "tk-TM",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["ru", "en"],
    SupportedCultures: ["tk-TM", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "993",
    PaymentTerm: "60",
  },
  TC: {
    ExtensionData: null,
    Iso2Code: "TC",
    Iso3Code: "TCA",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  TV: {
    ExtensionData: null,
    Iso2Code: "TV",
    Iso3Code: "TUV",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "688",
    PaymentTerm: "60",
  },
  UG: {
    ExtensionData: null,
    Iso2Code: "UG",
    Iso3Code: "UGA",
    DefaultCulture: "en-GB",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-GB", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "256",
    PaymentTerm: "60",
  },
  UA: {
    ExtensionData: null,
    Iso2Code: "UA",
    Iso3Code: "UKR",
    DefaultCulture: "uk-UA",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["uk", "en"],
    SupportedCultures: ["uk-UA", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{12}$|^\\d{10}$|^\\d{9}$",
    TaxIdFormat: "123456789012; 1234567890; 123456789",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "380",
    PaymentTerm: "60",
  },
  MK: {
    ExtensionData: null,
    Iso2Code: "MK",
    Iso3Code: "MKD",
    DefaultCulture: "mk-MK",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["mk-MK", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "389",
    PaymentTerm: "60",
  },
  EG: {
    ExtensionData: null,
    Iso2Code: "EG",
    Iso3Code: "EGY",
    DefaultCulture: "ar-EG",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["ar-EG", "en-US"],
    PostalCodeRegex: "^[1-9][0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "20",
    PaymentTerm: "60",
    SalesTerritory: "Egypt",

    IsSalesTerritoryRequired: "true",
  },
  GB: {
    ExtensionData: null,
    Iso2Code: "GB",
    Iso3Code: "GBR",
    DefaultCulture: "en-GB",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-GB", "en-US"],
    PostalCodeRegex:
      "^([gG][iI][rR][ ]?0[aA]{2,2}|[a-zA-Z]([0-9][0-9a-zA-Z]?|[a-zA-Z][0-9][0-9a-zA-Z]?)[ ]?[0-9][a-zA-Z]{2,2})$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    VatIdRegex: "^GB(([\\d]{3,3}[\\d]{4,4}[\\d]{2,2}([\\d]{3,3})?)|((GD|HA)[\\d]{3,3}))$",
    IsRegistrationNumberSupported: "false",
    TaxIdFormat: "GB#########",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "44",
    PaymentTerm: "60",
    SalesTerritory: ["EEA", "EUFTA"],

    IsSalesTerritoryRequired: "true",
  },
  GG: {
    ExtensionData: null,
    Iso2Code: "GG",
    Iso3Code: "GGY",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "44",
    PaymentTerm: "60",
  },
  JE: {
    ExtensionData: null,
    Iso2Code: "JE",
    Iso3Code: "JEY",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "44",
    PaymentTerm: "60",
  },
  IM: {
    ExtensionData: null,
    Iso2Code: "IM",
    Iso3Code: "IMN",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "44",
    PaymentTerm: "60",
  },
  TZ: {
    ExtensionData: null,
    Iso2Code: "TZ",
    Iso3Code: "TZA",
    DefaultCulture: "en-GB",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-GB", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "255",
    PaymentTerm: "60",
  },
  US: {
    ExtensionData: null,
    Iso2Code: "US",
    Iso3Code: "USA",
    DefaultCulture: "en-US",
    States: [
      "AL",
      "AK",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DE",
      "FL",
      "GA",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY",
      "DC",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["en", "es"],
    SupportedCultures: ["en-US", "es-US"],
    PostalCodeRegex: "^\\d{5}(-\\d{4})?$",
    IsPostalCodeRequired: "true",
    PhoneNumberRegex:
      "^(1[ \\-\\/\\.]?)?(\\((\\d{3})\\)|(\\d{3}))[ \\-\\/\\.]?(\\d{3})[ \\-\\/\\.]?(\\d{4})$",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    IsTaxIdSupported: "true",
    IsTaxIdOptional: "true",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
    SalesTerritory: "United States",

    IsSalesTerritoryRequired: "true",
  },
  VI: {
    ExtensionData: null,
    Iso2Code: "VI",
    Iso3Code: "VIR",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    PostalCodeRegex: "^\\d{5}(-\\d{4})?$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  BF: {
    ExtensionData: null,
    Iso2Code: "BF",
    Iso3Code: "BFA",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "226",
    PaymentTerm: "60",
  },
  UY: {
    ExtensionData: null,
    Iso2Code: "UY",
    Iso3Code: "URY",
    DefaultCulture: "es-UY",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["es", "en"],
    SupportedCultures: ["es-UY", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "598",
    PaymentTerm: "60",
  },
  UZ: {
    ExtensionData: null,
    Iso2Code: "UZ",
    Iso3Code: "UZB",
    DefaultCulture: "uz-Latn-UZ",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "ru"],
    SupportedCultures: ["uz-Latn-UZ", "en-US"],
    PostalCodeRegex: "^[0-9]{6,6}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{12}$",
    TaxIdFormat: "123456789012",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "998",
    PaymentTerm: "60",
  },
  VE: {
    ExtensionData: null,
    Iso2Code: "VE",
    Iso3Code: "VEN",
    DefaultCulture: "es-VE",
    States: [
      "Amazonas",
      "Anzo\u00e1tegui",
      "Apure",
      "Aragua",
      "Barinas",
      "Bol\u00edvar",
      "Carabobo",
      "Cojedes",
      "Delta Amacuro",
      "Distrito Federal",
      "Falc\u00f3n",
      "Federal Dependencies",
      "Gu\u00e1rico",
      "Lara",
      "M\u00e9rida",
      "Miranda",
      "Monagas",
      "Nueva Esparta",
      "Portuguesa",
      "Sucre",
      "T\u00e1chira",
      "Trujillo",
      "Vargas",
      "Yaracuy",
      "Zulia",
    ],

    IsStateRequired: "true",
    SupportedLanguages: ["es", "en"],
    SupportedCultures: ["es-VE", "en-US"],
    PostalCodeRegex: "^[0-9]{4,4}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "58",
    PaymentTerm: "60",
  },
  WF: {
    ExtensionData: null,
    Iso2Code: "WF",
    Iso3Code: "WLF",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "AsiaPacific",
    CountryCallingCodes: "681",
    PaymentTerm: "60",
  },
  WS: {
    ExtensionData: null,
    Iso2Code: "WS",
    Iso3Code: "WSM",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "APOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "685",
    PaymentTerm: "60",
  },
  YE: {
    ExtensionData: null,
    Iso2Code: "YE",
    Iso3Code: "YEM",
    DefaultCulture: "ar-YE",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "ar"],
    SupportedCultures: ["ar-YE", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "967",
    PaymentTerm: "60",
  },
  RS: {
    ExtensionData: null,
    Iso2Code: "RS",
    Iso3Code: "SRB",
    DefaultCulture: "sr-Latn-RS",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["sr-Latn-CS", "en", "sr-Cyrl"],
    SupportedCultures: ["sr-Latn-RS", "sr-cyrl-RS", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    VatIdRegex: "^\\d{9}$",
    TaxIdFormat: "123456789",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "381",
    PaymentTerm: "60",
  },
  ZM: {
    ExtensionData: null,
    Iso2Code: "ZM",
    Iso3Code: "ZMB",
    DefaultCulture: "en-GB",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: ["en-GB", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "260",
    PaymentTerm: "60",
  },
  BQ: {
    ExtensionData: null,
    Iso2Code: "BQ",
    Iso3Code: "BES",
    DefaultCulture: "nl-NL",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["nl"],
    SupportedCultures: ["nl-NL", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "599",
    PaymentTerm: "60",
  },
  CD: {
    ExtensionData: null,
    Iso2Code: "CD",
    Iso3Code: "COD",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en"],
    SupportedCultures: "fr-FR",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: ">MiddleEastAndAfrica",
    CountryCallingCodes: "243",
    PaymentTerm: "60",
  },
  IQ: {
    ExtensionData: null,
    Iso2Code: "IQ",
    Iso3Code: "IRQ",
    DefaultCulture: "ar-IQ",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "ar"],
    SupportedCultures: ["ar-IQ", "en-US"],
    PostalCodeRegex: "^[0-9]{5,5}$",
    IsPostalCodeRequired: "true",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "964",
    PaymentTerm: "60",
  },
  SO: {
    ExtensionData: null,
    Iso2Code: "SO",
    Iso3Code: "SOM",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "252",
    PaymentTerm: "60",
  },
  SS: {
    ExtensionData: null,
    Iso2Code: "SS",
    Iso3Code: "SSD",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "MiddleEastAndAfrica",
    CountryCallingCodes: "211",
    PaymentTerm: "60",
  },
  SX: {
    ExtensionData: null,
    Iso2Code: "SX",
    Iso3Code: "SXM",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "1",
    PaymentTerm: "60",
  },
  XS: {
    ExtensionData: null,
    Iso2Code: "XS",
    Iso3Code: "XSA",
    DefaultCulture: "nl-NL",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["nl", "en"],
    SupportedCultures: ["nl-NL", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "599",
    PaymentTerm: "60",
  },
  XE: {
    ExtensionData: null,
    Iso2Code: "XE",
    Iso3Code: "XSE",
    DefaultCulture: "nl-NL",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["nl", "en"],
    SupportedCultures: ["nl-NL", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "599",
    PaymentTerm: "60",
  },
  AX: {
    ExtensionData: null,
    Iso2Code: "AX",
    Iso3Code: "ALA",
    DefaultCulture: "sv-SE",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["sv", "en"],
    SupportedCultures: ["sv-SE", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "WesternEurope",
    CountryCallingCodes: "358",
    PaymentTerm: "60",
  },
  XK: {
    ExtensionData: null,
    Iso2Code: "XK",
    Iso3Code: "XKS",
    DefaultCulture: "en-US",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en"],
    SupportedCultures: "en-US",
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "Europe",
    CountryCallingCodes: "383",
    PaymentTerm: "60",
  },
  BL: {
    ExtensionData: null,
    Iso2Code: "BL",
    Iso3Code: "BLM",
    DefaultCulture: "fr-FR",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["fr", "en"],
    SupportedCultures: ["fr-FR", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "false",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "AOC",
    GeographicRegion: "NorthAndLatinAmerica",
    CountryCallingCodes: "590",
    PaymentTerm: "60",
  },
  XJ: {
    ExtensionData: null,
    Iso2Code: "XJ",
    Iso3Code: "XJA",
    DefaultCulture: "nb-NO",
    States: null,
    IsStateRequired: "false",
    SupportedLanguages: ["en", "nb"],
    SupportedCultures: ["nb-NO", "en-US"],
    IsPostalCodeRequired: "false",
    IsCityRequired: "true",
    IsVatIdSupported: "true",
    IsTaxIdOptional: "true",
    IsRegistrationNumberSupported: "false",
    ResellerAgreementRegion: "EOC",
    GeographicRegion: "WesternEurope",
    CountryCallingCodes: "47",
    PaymentTerm: "60",
  },
};
